import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { IDashboardApi } from './types';

export const dashboard: IDashboardApi = {
  getBalance: () => http.get(endpoint.dashboard.GET_BALANCE).then((res) => res.data),
  getPhoneCalls: () => http.get(endpoint.dashboard.GET_PHONE_CALLS).then((res) => res.data),
  getRegisteredUnregistered: () =>
    http.get(endpoint.dashboard.GET_REGISTERED_UNREGISTERED).then((res) => res.data),
  getTopChannels: () => http.get(endpoint.dashboard.GET_TOP_CHANNELS).then((res) => res.data),
  getTotalChannelsByCategory: () =>
    http.get(endpoint.dashboard.GET_TOTAL_CHANNELS_BY_CATEGORY).then((res) => res.data),
  getTotalGroupsByCategory: () =>
    http.get(endpoint.dashboard.GET_TOTAL_GROUPS_BY_CATEGORY).then((res) => res.data),
  getTotalUsersOnPlatform: () =>
    http.get(endpoint.dashboard.GET_TOTAL_USERS_ON_PLATFORM).then((res) => res.data),
};
